import { render, staticRenderFns } from "./MainPainel.vue?vue&type=template&id=242b859d&lang=pug&"
import script from "./MainPainel.vue?vue&type=script&lang=js&"
export * from "./MainPainel.vue?vue&type=script&lang=js&"
import style0 from "./MainPainel.vue?vue&type=style&index=0&id=242b859d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports